// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"261":"b51a75a0","805":"2e3c599a","904":"938b1a55"}[chunkId] + ".js";
};